export default "__VITE_ASSET__paIGQkIx__"